import React, { useEffect } from 'react'
import RichText from '@components/RichText'
import Pages from '@components/_Investors/Pages'
import {
  ContentWrapper,
} from './index.style'
import PropTypes from 'prop-types'

const ListedContent = ({ list }) => {

  var options = [];

  const slugify = str => {
    return str.toLowerCase().trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
  }

  Object.values(list).map((item) => {
    var option = {
      label: item.textOld.textOld,
      value: slugify(item.textOld.textOld),
      content: <RichText content={item.text} />,
    }
    options.push(option);
  });

  const newLink = [{label: 'Data Processing Agreement', value: 'data-processing-agreement', type: 'link'}]

  return (
    <ContentWrapper>
      <Pages options={options} extraLinks={newLink}/>
    </ContentWrapper>
  )
}

ListedContent.propTypes = {
  list: PropTypes.array
}

export default ListedContent